import styled from 'styled-components';
import StipeCurrencySelect from './StipeCurrencySelect';

const StipeCurrencySelectStyled = styled(StipeCurrencySelect)`
  ${props => props.theme.input.select};
`;

export default StipeCurrencySelectStyled;
